export default {
  stroke: {
    light: 'fal',
    solid: 'fas',
    regular: 'far',
    duo: 'fad',
  },
  mainTabNavigator: {
    home: 'home-circle',
    inbox: 'comment-lines',
    au: 'calendar-day',
    menu: 'bars',
    explore: 'compass',
  },
  groups: {
    main: 'users',
    add: 'account-multiple-plus',
    bulletin: 'calendar-day',
    settings: 'cog',
    ticket: 'ticket-alt',
    pin: 'thumbtack',
  },
  julevenner: {
    house: 'home-outline',
    circle: 'checkbox-blank-circle-outline',
    info: 'information-outline',
  },
  activities: {
    activities: 'calendar-day',
    edit: 'edit',
    categories: 'list',
    list: 'list-ul',
    map: 'map',
    trash: 'trash-alt',
  },
  stackMenu: {
    stories: 'book-open',
    cookies: 'cookie-bite',
    sponsors: 'handshake',
    speakTogether: 'comments',
    partners: 'handshake-alt',
    employment: 'suitcase',
    projects: 'clipboard-check',
    learnDanish: 'globe-europe',
    privatePoly: 'user-shield',
    conditions: 'file-check',
    award: 'award',
    virus: 'virus',
    grip: 'grip-vertical',
  },
  list: 'list',
  info: 'info-circle',
  settings: 'cog',
  sms: 'comments',
  push: 'bell',
  pushOff: 'bell-slash',
  unions: 'users-class',
  backButton: 'chevron-left',
  rightArrow: 'chevron-right',
  arrowUp: 'chevron-up',
  arrowDown: 'chevron-down',
  pictureSymbol: 'images',
  leftArrow: 'chevron-left',
  cameraSymbol: 'camera',
  create: 'plus-circle',
  rotate: 'sync',
  rotateLeftSymbol: 'undo',
  rotateRightSymbol: 'redo',
  close: 'times',
  error: 'times',
  deleteRoundImage: 'times-circle',
  emailSymbol: 'envelope',
  passwordSymbol: 'lock',
  favoriteSymbol: 'star',
  messageSend: 'paper-plane',
  user: 'user',
  userPlus: 'user-plus',
  eyeIcon: 'eye',
  eyeOffIcon: 'eye-slash',
  checkBlank: 'square',
  checkMarked: 'check-square',
  article: 'newspaper',
  radio: 'radio-alt',
  television: 'tv-retro',
  phone: 'phone-alt',
  check: 'check',
  arrowUpCircle: 'arrow-circle-up',
  arrowDownCircle: 'arrow-circle-down',
  volunteer: 'user-headset',
  video: 'tv-retro',
  recorder: 'video',
  calendar: 'calendar-alt',
  map: 'map',
  mapMarker: 'map-marker-alt',
  edit: 'edit',
  bubbles: 'bubbles',
  radioButton: 'circle',
  city: 'building',
  globe: 'globe',
  clock: 'clock',
  dotsVertical: 'ellipsis-v',
  dotsHorizontal: 'ellipsis-h',
  delete: 'trash',
  leave: 'sign-out',
  paperclip: 'paperclip',
  verifiedUser: 'user-check',
  openLock: 'lock-open-alt',
  bobl: 'bobl',
  plus: 'plus',
  minus: 'minus',
  hatSanta: 'hat-santa',
  distance: 'arrows-alt-h',
  host: 'home-lg-alt',
  guest: 'wreath',
  afterSignup: 'candy-cane',
  gifts: 'gifts',
  shoppingBags: 'bags-shopping',
  christmasTree: 'tree-christmas',
  glassCheers: 'glass-cheers',
  questionCircle: 'question-circle',
  pen: 'pen',
  checkCircle: 'check-circle',
  circle: 'circle',
  chevronLeft: 'chevron-left',
  chevronRight: 'chevron-right',
  reload: 'redo-alt',
  commentDots: 'comment-dots',
  flag: 'flag-alt',
  history: 'history',
  download: 'arrow-to-bottom',
  link: 'link',
  filter: 'filter',
  faculty: 'graduation-cap',
  save: 'save',
  book: 'book',
  child: 'child',
  arrowRight: 'arrow-right',
  login: 'sign-in-alt',
  shield: 'shield',
  file: 'file-alt',
  image: 'image',
  arrowLeft: 'arrow-left',
  arrowToBottom: 'arrow-to-bottom',
  copy: 'copy',
  calenderStar: 'calendar-star',
  calendarDay: 'calendar-day',
  search: 'search',
  ticket: 'ticket',
  users: 'users',
  sortDown: 'sort-down',
  usersMedical: 'users-medical',
  warning: 'exclamation-triangle',
  home: 'home',
  exclamationCircle: 'exclamation-circle',
}
